import React from 'react';
import PropTypes from 'prop-types';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow 
} from '@mui/material';

import AcTableCell from './AcTableCell';
import DcTableCell from './DcTableCell';

const SummaryWithoutUtil = ({data}) => {

  const {
    acSockets,
    dcSockets,
    acKwh,
    dcKwh,
    acTransactions,
    dcTransactions,
    energySource,
  } = data;

  const hasAC = acSockets > 0;
  const hasDC = dcSockets > 0;

  return (
    <div className="mb-6">
      <TableContainer>
        <Table 
          aria-label="ProfitShareRevenue" 
          sx={{
            borderCollapse: 'separate',
            borderRadius: '15px',
            border: '1px solid rgb(224, 224, 224)',
          }}>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <AcTableCell hasAC={hasAC} hasDC={hasDC} header data={'AC Sockets'}/>
              <DcTableCell hasAC={hasAC} hasDC={hasDC} header data={'DC Sockets'}/>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Total charging sockets on site</TableCell>
              <AcTableCell hasAC={hasAC} hasDC={hasDC} data={acSockets}/>
              <DcTableCell hasAC={hasAC} hasDC={hasDC} data={dcSockets}/>
            </TableRow>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Energy consumed (kWh)</TableCell>
              <AcTableCell hasAC={hasAC} hasDC={hasDC} data={acKwh}/>
              <DcTableCell hasAC={hasAC} hasDC={hasDC} data={dcKwh}/>
            </TableRow>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Number of sessions</TableCell>
              <AcTableCell hasAC={hasAC} hasDC={hasDC} data={acTransactions}/>
              <DcTableCell hasAC={hasAC} hasDC={hasDC} data={dcTransactions}/>
            </TableRow>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Energy Source</TableCell>
              <AcTableCell hasAC={hasAC} hasDC={hasDC} data={energySource}/>
              <DcTableCell hasAC={hasAC} hasDC={hasDC} data={energySource}/>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default SummaryWithoutUtil;

SummaryWithoutUtil.propTypes = {
  data: PropTypes.object.isRequired,
};
